export const defaultConfigColunas = [
  { nome: "id", exibir: true },
  { nome: "usuario", exibir: true },
  { nome: "dataCadastro", exibir: true },
  { nome: "empresa", exibir: true },
  { nome: "status", exibir: true },
  { nome: "qtdVinculado", exibir: true },
  { nome: "qtdFinalizado", exibir: true },
];

export const colunaLabels: Record<string, string> = {
  id: "LOTE",
  usuario: "USUÁRIO",
  dataCadastro: "CADASTRO",
  empresa: "EMPRESA",
  status: "STATUS",
  qtdVinculado: "QTD VINCULADO",
  qtdFinalizado: "QTD FINALIZADO",
};

/** Chave usada para persistir a configuração de colunas no localStorage */
export const CHAVE_CONFIG_COLUNAS = "config_pagamento_taxa_colunas";
